import { createApp } from "vue";
import StudentIndividualAssignmentsManager from "./components/StudentIndividualAssignmentsManager.vue";
import { parseBoolean } from "./utils/parseBoolean";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

const MOUNT_SELECTOR = "[data-vue-student-individual-assignments]";

export function initStudentIndividualAssignmentsApp(root = document) {
  const apps = [];

  for (const element of getMountElements(root, MOUNT_SELECTOR)) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }

    const payload = readPayload(element);
    const app = createApp(StudentIndividualAssignmentsManager, {
      stateUrl: payload.stateUrl || "",
      initialState: payload.initialState || {},
      subjectOptions: Array.isArray(payload.subjectOptions) ? payload.subjectOptions : [],
      characterOptions: Array.isArray(payload.characterOptions) ? payload.characterOptions : [],
      canEdit: parseBoolean(payload.canEdit),
      canOpenReadonlyModal: parseBoolean(payload.canOpenReadonlyModal),
      apiUrl: payload.apiUrl || "",
      deleteTemplate: payload.deleteTemplate || "",
      csrfToken: payload.csrfToken || "",
      teacherUrlTemplate: payload.teacherUrlTemplate || "",
    });

    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }

  return apps;
}
